module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/cowork-5-973614a5daff429e65070e08388b5e20.jpg";